import { useContext, useEffect } from 'react';

import './index.css';
import { LoadSavedQuotationsCard, QuotationInfoContext } from '../../../shared';
import { LOADING_SAVED_QUOTATIONS_STATES } from '../../../shared/interfaces/loading-saved-quotations-states-enum';

export const LoadSavedQuotation = () => {

  const {
    loadSaveQuotationState,
    setLoadSaveQuotationState,
  } = useContext(QuotationInfoContext);

  useEffect(() => {
    setLoadSaveQuotationState(LOADING_SAVED_QUOTATIONS_STATES.INIT_LOADING);
  }, []);

  return <LoadSavedQuotationsCard />;
};
